module.exports = __webpack_public_path__ + "012c6bdd0d7f96dfcbe7ee0c179c5d74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/pic4.png
// module id = 1863
// module chunks = 0